import { Pipe, PipeTransform } from '@angular/core';
import { ShelfTalkerCardData } from '../../../models/shelf-talkers/shelf-talker-card-data';

@Pipe({
  name: 'shelfTalkerCardDataBasicMethod',
  standalone: false
})
export class ShelfTalkerCardDataBasicMethodPipe implements PipeTransform {
  transform(shelfTalkerCardData: ShelfTalkerCardData, methodKey: string, argument?: any): any {
    return shelfTalkerCardData?.[methodKey]?.(argument);
  }
}
